'use client';

import { SvgIcon, SvgIconProps } from '../components';

export const Apple = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M18.8917 12.7256C18.8651 9.83893 21.316 8.43454 21.428 8.36915C20.04 6.39601 17.8886 6.12642 17.1325 6.10492C15.3256 5.91952 13.5729 7.15912 12.6524 7.15912C11.7136 7.15912 10.2961 6.12284 8.76844 6.15329C6.80258 6.18285 4.96349 7.29257 3.95484 9.01582C1.87323 12.5295 3.42571 17.693 5.42005 20.5331C6.41768 21.9241 7.58341 23.4772 9.10925 23.4225C10.602 23.3625 11.1596 22.4946 12.9611 22.4946C14.7459 22.4946 15.2696 23.4225 16.8257 23.3876C18.4278 23.3625 19.4364 21.9904 20.3992 20.5869C21.552 18.9926 22.015 17.4225 22.0334 17.3419C21.9957 17.3293 18.922 16.1856 18.8917 12.7256Z"
      fill="white"
    />
    <path
      d="M15.9521 4.23657C16.755 3.25762 17.3043 1.92577 17.1518 0.574219C15.9898 0.624376 14.5365 1.35792 13.6996 2.31538C12.9592 3.1591 12.2978 4.542 12.4687 5.84249C13.774 5.93743 15.1143 5.20031 15.9521 4.23657Z"
      fill="white"
    />
  </SvgIcon>
);
